import styled from 'styled-components'
import {
  colors,
  spacing,
  heading,
  body,
  typographyMixin,
  mediaQuery,
} from 'src/constants/marketing-ds'

// Section Header Component - combines title and optional subtitle
export const SectionHeader = ({
  title,
  titleLevel = 'h2',
  centered = true,
  variant = 'dark',
  maxWidth: headerMaxWidth,
  className,
  ...props
}) => {
  const TitleTag = titleLevel

  return (
    <StyledSectionHeader
      $centered={centered}
      $variant={variant}
      $maxWidth={headerMaxWidth}
      className={className}
      {...props}
    >
      <TitleTag className="section-title">{title}</TitleTag>
    </StyledSectionHeader>
  )
}

const StyledSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};

  ${mediaQuery.tablet} {
    gap: ${spacing.lg};
  }

  ${({ $centered }) =>
    $centered &&
    `
    text-align: center;
    align-items: center;
  `}

  ${({ $maxWidth }) =>
    $maxWidth &&
    `
    max-width: ${$maxWidth};
    margin-left: auto;
    margin-right: auto;
  `}

  .section-title {
    color: ${({ $variant }) => ($variant === 'light' ? colors.white : colors.slate[60])};
    margin: 0;
    ${typographyMixin(heading.md)}

    ${mediaQuery.tablet} {
      ${typographyMixin(heading.lg)}
    }
  }

  .section-subtitle {
    color: ${({ $variant }) => ($variant === 'light' ? colors.white : colors.slate[60])};
    margin: 0;
    ${typographyMixin(body.lg)}

    ${mediaQuery.tablet} {
      ${typographyMixin(body.xl)}
    }
  }
`

export const BannerHeader = ({ title, variant = 'dark' }) => {
  return <StyledBannerHeader $variant={variant}>{title}</StyledBannerHeader>
}

const StyledBannerHeader = styled.h3`
  text-align: center;
  color: ${({ $variant }) => ($variant === 'light' ? colors.white : colors.slate[60])};
  ${typographyMixin(heading.md)}
`

export const SectionContainer = ({ children, backgroundColor = 'transparent' }) => {
  return (
    <StyledSectionContainer $backgroundColor={backgroundColor}>{children}</StyledSectionContainer>
  )
}

const StyledSectionContainer = styled.div`
  background: ${({ $backgroundColor }) => $backgroundColor};
  padding: 0 ${spacing.xs};
  ${mediaQuery.tablet} {
    padding: 0 ${spacing.lg};
  }
  ${mediaQuery.desktop} {
    padding: 0 ${spacing.xl};
  }
`
